import React from "react";
import "./RecentTransactions.css";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useSelector } from "react-redux";
import { selectRecentTransactions } from "../features/recentTransactions/recentTransactionSlice";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#008556",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(merchant_name, date, amount, invoice) {
  return { merchant_name, date, amount, invoice };
}

const rows = [
  createData("WallGreens", "11/12/17", "$45.09", 2423423),
  createData("Forever 21", "09/12/17", "$195.09", 3745655),
  createData("Nike Store", "08/12/17", "$24.99", 2409873),
];

const RecentTransactions = () => {
  const transactions = useSelector(selectRecentTransactions);
  const recentTransactions = transactions?.creditCard;
  // console.log(recentTransactions);
  return (
    //     <div
    //       className="flex bg-white text-[#14B084] w-5/12 px-2 pb-5 pt-2 rounded-lg justify-between
    // mr-4 flex-col"
    //     >
    //       <div className="flex justify-between mx-2 mb-2">
    //         <h3 className="card__title font-semibold text-xl">
    //           Recent Transactions
    //         </h3>
    //         <div className="flex flex-row justify-evenly recentTransactions__buttons">
    //           <button className="card__button text-white bg-gradient-to-r from-[#008556] to-[#14B084] text-center rounded-2xl text-xs py-2 font-medium ml-auto px-3 ">
    //             All
    //           </button>
    //           <button className="card__button text-white bg-gradient-to-r from-[#008556] to-[#14B084] text-center rounded-2xl text-xs py-2 font-medium ml-auto px-2 ">
    //             Credit
    //           </button>
    //           <button className="card__button text-white bg-gradient-to-r from-[#008556] to-[#14B084] text-center rounded-2xl text-xs py-2 font-medium ml-auto px-2 ">
    //             Debit
    //           </button>
    //         </div>
    //       </div>
    //       <TableContainer component={Paper}>
    //         <Table
    //           sx={{ minWidth: 400 }}
    //           size="small"
    //           aria-label="customized table"
    //           className="rounded-lg"
    //         >
    //           <TableHead>
    //             <TableRow>
    //               <StyledTableCell>Merchants</StyledTableCell>
    //               <StyledTableCell align="left">Date</StyledTableCell>
    //               <StyledTableCell align="left">Amount</StyledTableCell>
    //               <StyledTableCell align="left">Invoice no.</StyledTableCell>
    //             </TableRow>
    //           </TableHead>
    //           <TableBody>
    //             {recentTransactions?.map((row) => (
    //               <StyledTableRow key={row.merchant}>
    //                 <StyledTableCell component="th" scope="row">
    //                   {row.merchant}
    //                 </StyledTableCell>
    //                 <StyledTableCell align="left">{row.date}</StyledTableCell>
    //                 <StyledTableCell align="left">{row.amount}</StyledTableCell>
    //                 <StyledTableCell align="left">{row.invoiceNo}</StyledTableCell>
    //               </StyledTableRow>
    //             ))}
    //           </TableBody>
    //         </Table>
    //       </TableContainer>
    //       <button className="card__button bg-gradient-to-r from-[#008556] to-[#14B084] text-white text-center rounded-2xl text-sm py-2 font-medium ml-auto px-4 ">
    //         View All
    //       </button>
    //     </div>
    <div className="flex bg-gradient-to-r from-[#008556] to-[#14B084] text-white w-5/12 px-2 py-3 rounded-lg  mr-4 flex-col">
      <h3 className="card__title font-semibold text-xl ml-4">
        Recent Transactions
      </h3>
      <iframe src="http://44.195.241.28:3001" className="iframe mb-2" />
      <button className="card__button bg-[#008556] text-center rounded-xl text-sm py-2 font-medium ml-auto px-2 ">
        View All
      </button>
    </div>
  );
};

export default RecentTransactions;
